import React, { useCallback } from 'react';

import {
  StepWizardActionContainer,
  StepWizardFieldWithBorder,
} from 'src/presentation/components/pages/email/components/StepWizardLayout';
import { Button } from 'src/presentation/components/agent_desktop_components';
import { H3 } from '@ad-scripts/presentation/components/common/headers';
import ExternalLink from 'src/presentation/components/pages/shared/ExternalLink';
import { StyledDescription } from './shared/elements';

const PortPhoneNumberForm = ({
  firstStep,
  setInitState,
  nextStep,
}: {
  firstStep?;
  nextStep?;
  setInitState;
}): JSX.Element | null => {
  const setUpAnotherNumberHandler = useCallback(() => {
    setInitState();
    firstStep();
  }, [setInitState, firstStep]);

  return (
    <>
      <StepWizardFieldWithBorder>
        <H3 data-aid="wizard-title">Port or forward a phone number form another provider</H3>
        <StyledDescription>
          To port or forward a number you already own for voice calls into Gladly you’ll need to{' '}
          <ExternalLink
            data-aid="submit a request"
            label="submit a request"
            to="https://help.gladly.com/docs/call-forwarding-vs-porting"
          />
          . Once your request has been processed, the number will be available in Gladly to configure.
        </StyledDescription>
      </StepWizardFieldWithBorder>
      <StepWizardActionContainer>
        <Button data-aid="editor-next" type={Button.Types.PRIMARY} onClick={nextStep}>
          Next
        </Button>
        <Button data-aid="editor-save" type={Button.Types.SECONDARY} onClick={setUpAnotherNumberHandler}>
          Set up another number
        </Button>
      </StepWizardActionContainer>
    </>
  );
};

export default PortPhoneNumberForm;
